import { Link } from "react-router-dom"
import { Bell } from "lucide-react"
import "./NewsTicker.css"

const latestBlogs = [
  { id: 1, title: "Irregular Periods Causes Symptoms and Treatment", link: "/blogs/irregular-periods-causes-symptoms-and-treatment-options-a-complete-guide-by-pranaam-hospitals" },
  { id: 2, title: "Understanding Preterm Birth Neonatal Care", link: "/blogs/understanding-preterm-birth-neonatal-care" },
  // { id: 3, title: "Free Health Checkup Camp for Senior Citizens - Register Now", link: "/blogs/health-checkup-camp" },
  // { id: 4, title: "World Heart Day Special: Tips for a Healthy Heart", link: "/blogs/world-heart-day" },
]

export function NewsTicker() {
  return (
    <div className="news-ticker-container">
      <div className="news-ticker-label">
        <Bell className="w-4 h-4 text-white-600 mr-2" />
        What's New
      </div>
      <div className="news-ticker-wrapper">
        <div className="news-ticker-content">
          {latestBlogs.map((blog) => (
            <Link key={blog.id} to={blog.link} className="news-ticker-item">
              {blog.title}
            </Link>
          ))}
          {/* Duplicate for seamless loop */}
          {latestBlogs.map((blog) => (
            <Link key={`dup-${blog.id}`} to={blog.link} className="news-ticker-item">
              {blog.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
